import React from "react";
export function Footer() {
  return <footer className="bg-navy-950 px-4 pb-32 pt-10 text-center text-white/60 md:pb-28" data-id="element-158" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl border-t border-white/10 pt-8" data-id="element-159" data-mp="3ggty8ibanj58">
        <p className="text-sm font-extrabold tracking-wide text-white" data-id="element-160" data-mp="32onjn0nshk7w">
          ORTHO CASE <span className="text-brand-cyan" data-id="element-161" data-mp="36oxzr65apr0h">COMMAND CENTER™</span>
        </p>
        <p className="mt-1 text-sm" data-id="element-162" data-mp="36n3gdw9oa6yi">Created by Dr. Nathan Brooks</p>
        <p className="mt-4 text-sm leading-relaxed" data-id="element-163" data-mp="3ufjvbxy45itl">
          A visual case-planning system for dental professionals who want to organize complex orthodontic cases with greater clarity, consistency and structure.
        </p>
        <p className="mt-6 text-xs" data-id="element-164" data-mp="3lgonyijc22op">© 2026 · Dr. Nathan Brooks · Ortho Case Command Center™ · All rights reserved.</p>
      </div>
    </footer>;
}